import React from 'react'
import { WeekViewCategory } from '../../types'
import { formatCategoryKey, formatDateKey } from '../../useMomentMap/momentMap'
import { WeekViewGlobalContext } from '../../weekViewGlobalContext'
import * as styles from './styles'

type CategoryColumnProps = {
  category: WeekViewCategory
  date: Date
}

const CategoryColumn: React.FC<
  React.PropsWithChildren<CategoryColumnProps>
> = ({ category, children, date }) => {
  const { setActiveColumn } = React.useContext(WeekViewGlobalContext)

  const onMouseEnter = () => {
    setActiveColumn({ date, category: category.title })
  }
  const onMouseLeave = () => {
    setActiveColumn({ date: null, category: null })
  }

  return (
    <div
      className={`category-column ${formatCategoryKey(
        category
      )} ${formatDateKey(date)}`}
      css={styles.dayWrapper}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div css={styles.day}>{children}</div>
    </div>
  )
}

export { CategoryColumn }
